import { ISwimlanesLocalStorage, SWIMLANES_LOCALSTORAGE } from '../types';

export const setSwimlanesLocalStorage = (
    swimlanesLocalStorage: ISwimlanesLocalStorage
) => {
    localStorage.setItem(SWIMLANES_LOCALSTORAGE, JSON.stringify(swimlanesLocalStorage));
}
